@if (!onlyFeatures) {
  <div>
    {{ 'PLAYER_PROFILE_FEATURES_TEXT_1' | translate }}
  </div>
  <div class="pt-2">
    {{ 'PLAYER_PROFILE_FEATURES_TEXT_2' | translate }}
  </div>
}
<div [class.pt-2]="!onlyFeatures">
  <p-table #table
           class="frontend p-datatable-sm"
           [value]="rows"
           dataKey="feature"
           [selectionMode]="undefined"
           [stripedRows]="true" [showGridlines]="true">

    <ng-template pTemplate="header">
      <tr>
        <th>{{'FEATURE' | translate}}</th>
        <th style="width: 40px">Basic</th>
        <th style="width: 40px">Pro</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-expanded="expanded">
      <tr [pRowToggler]="item">
        <td>
          <div class="flex align-items-center gap-2 cursor-pointer hover-accent" [class.text-gray-400]="item.comingSoon">
            {{item.feature | translate}}
            @if (item.comingSoon) {
              <i class="pi pi-lightbulb text-sm"></i>
              <span class="font-italic text-orange-frontend">
                {{ 'COMING_SOON' | translate }}
              </span>
            } @else if (item.new) {
              <span class="material-symbols-outlined text-orange-frontend text-base">release_alert</span>
              <span class="text-orange-frontend">{{'NEW' | translate}}</span>
            } @else {
              @if (item.description) {
                <i class="pi pi-info-circle text-sm"></i>
              }
            }
          </div>
        </td>
        <td class="text-center">
          @if (item.basic) {
            <i class="pi pi-check-circle green"></i>
          }
        </td>
        <td class="text-center">
          @if (item.pro) {
            <i class="pi pi-check-circle green"></i>
          }
        </td>
      </tr>
    </ng-template>

    <ng-template #expandedrow let-item>
      <tr>
        <td colspan="3">
          <div class="text-gray-400">
            {{item.description | translate}}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  @if (!onlyFeatures && system() !== 'ios') {
    <app-loading [active]="isLoading" [center]="true"/>
    @if (settings?.pricePremiumYear > 0) {
      <h3>{{'COSTS' | translate}}</h3>
      @if (settings.daysPremiumRegistration > 0) {
        <app-info-text [text]="'PLAYER_PROFILE_FREE_PRO_DAYS_TEXT' | translate: {value: settings.daysPremiumRegistration}"
                       color="text-gray-300"/>
      }
      <div class="pt-2">
        {{ 'PLAYER_PROFILE_FEE_PRO_TEXT' | translate: {value: settings.pricePremiumYear | number: '1.2-2'} }}
      </div>
    }
  }
</div>
